export default __webpack_public_path__ + "static/media/cleanproStep2-2.9e746d3c.png";